import type { EventParticipant, PrincipalCalendarAttendeePartstat } from 'models';
import { useCallback } from 'react';

export const useGetRsvpFromAttandee = () =>
  useCallback((partstat: PrincipalCalendarAttendeePartstat): EventParticipant['rsvp'] => {
    switch (partstat) {
      case 'ACCEPTED':
        return 'going';
      case 'DECLINED':
        return 'not_going';
      case 'NEEDS-ACTION':
        return 'pending';
    }
  }, []);
